// ImageSlider.js
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import images5 from "./images/cric/images.jpg";
import images1 from "./images/cric/images1.jpg";
import images2 from "./images/cric/images2.jpg";
import images3 from "./images/cric/images3.jpg";
import images4 from "./images/cric/images4.jpg";
import images6 from "./images/cric/images5.jpg";
import './ImageSlider.css'



const ImageSlider = () => {
  const images = [images5, images1, images2, images3, images4, images6];

  const settings = {
    infinite: true,
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // Adjust the speed (in milliseconds) for auto sliding,

  };

  return (
    <Slider {...settings} className='slider'>
      
      
      {images.map((image, index) => (
        <div key={index}>
         
          <img src={image} alt={`Slide ${index + 1}`} />
        </div>
      ))}
    </Slider>
  );
};

export default ImageSlider;
